var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',{staticClass:"h-full",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Buchungen in der Woche")]},proxy:true}])},[_vm._v(" "),_c('chart-bar',{attrs:{"data":_vm.bookings,"labels":_vm.labels,"headline":'Buchungen'}}),_vm._v(" "),_c('capacity')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }